import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MoonCrescent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M8.956 2.912c.165-.051.307 0 .421.167.125.182.17.458.077.704-1.207 3.185-.085 6.45 2.092 8.599s5.472 3.25 8.686 2.043a.76.76 0 0 1 .687.075q.232.161.148.403c-1.52 4.518-6.452 7.444-11.3 6.377-4.885-1.073-7.218-4.972-7.266-8.975-.048-4.023 2.21-8.062 6.455-9.393Zm8.049.27a.612.612 0 0 1 1.101 0l.638 1.323c.158.328.423.594.751.752l1.322.637a.611.611 0 0 1 0 1.101l-1.322.638a1.6 1.6 0 0 0-.75.752l-.639 1.322a.612.612 0 0 1-1.101 0l-.637-1.322a1.6 1.6 0 0 0-.752-.752l-1.322-.638a.612.612 0 0 1 0-1.101l1.322-.637c.329-.158.594-.424.752-.752z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MoonCrescent) as SvgIcon;
export { ForwardRef as ReactComponent };
